export const retrieveModel = async ( functionParameters = {} ) => {
    
    const {  token, isCopying, title, addToSubmissionData, submissionFuncPath, sideMenuToUse} = functionParameters;
    let {smartboxStorageName, modelPath, url, urlDestination, submitText } = functionParameters;

    if(!modelPath) throw "** ERROR: Smetio said model path must be provided **";

    if( smartboxStorageName in window){
   
        const {idOfcurrentlyVisibleSmartBox} = window[smartboxStorageName];
        window[smartboxStorageName]["smartboxes"][idOfcurrentlyVisibleSmartBox].animate({ animation: "shakeX" });
        window[smartboxStorageName]["smartboxes"][idOfcurrentlyVisibleSmartBox].activate();
        return false;
    };
    

    const appClass = window.smetioApp;

    const apiEndPoint = window.apiEndPoint;
    const language = window.userLanguage;

    const axios = (await import(/* webpackPrefetch: true */ "axios")).default;
    const { displayAndStoreSmartboxWithPreloader } = (await import(/* webpackPrefetch: true */ "../../display/displayAndStoreSmartboxWithPreloader.js"));
   
    const smartBoxTitle = title || "";
    const { preloader, smetioSmartbox, backBtnIsClicked } = await displayAndStoreSmartboxWithPreloader({ title: smartBoxTitle, smartboxStorageName });

    url = url || `${apiEndPoint}/apps/${appClass.appUserInterface }/${sideMenuToUse}/model/${language}`;

    const res = await axios.get(url, {params:{token, modelPath, ...addToSubmissionData } }).then(async (response) => {

        let model = response.data;

        if (model.error) {
            backBtnIsClicked();
            return window.smetioVisitor.showNotification({ type: "danger", body: [{ message: model.msg }] });
        };

        const { modelPath, instructionTitle, instructionSubtitle, token, doNotSaveFormData, newUrlDestination, addToSubmissionData} = model;
        model = model.model;

        const { newVersionOfConvertModelToInputs } = (await import(/* webpackPrefetch: true */ "./../../../classes/universal_methods/newVersionOfConvertModelToInputs.js"));
        
        const confirmationInput = await newVersionOfConvertModelToInputs({
            model, 
            withSubmitButton: true, 
            withFullContainerDiv: true,
            submitText: model.submitText ?? submitText ?? "txt38",
            doNotShowInstruction: instructionSubtitle ? false : true,
            instructionTitle,
            instructionSubtitle,
            submissionFunctionDetails: {
                functionPath:submissionFuncPath,
                functionParameters: {
                    ...functionParameters,
                    appClass, 
                    preloader, 
                    smetioSmartbox, 
                    token, 
                    smartboxStorageName, 
                    isCopying,
                    title,
                    urlDestination:newUrlDestination || urlDestination,
                    doNotSaveFormData,            
                },
                addToSubmissionData: {...addToSubmissionData, token, isCopying, modelPath }
            }
        });
    
        const newPreloaderDisplay = preloader.render();
  
        const content = `
          ${newPreloaderDisplay}
          ${confirmationInput}
        `;
        preloader.hide();
    
        smetioSmartbox.updateContent(content);

    }).catch((error) => {

        console.log(error);
        return window.smetioVisitor.showNotification({ type: "danger", body: [{ message: "txt423" }] });

    }).finally(() => {
        preloader.hide();
    });

    return res;
};